import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppConfig } from '@config/app.config';
import { AccountingEventsService } from '@core/services/accounting-events.service';
import { GeneralsService } from '@core/services/generals.service';
import { Constants } from '@shared/class/constants.class';
import { AccountingEvent } from '@shared/interfaces/accounting-event';

@Component({
  selector: 'app-accounting-events-edit',
  templateUrl: './accounting-events-edit.component.html'
})
export class AccountingEventsEditComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public accountingEvent: AccountingEvent;
  public accountingEventsList: Array<AccountingEvent> = [];
  public accountingEventForm: FormGroup;

  constructor(
    public appConfig: AppConfig,
    private generalsService: GeneralsService,
    private accountingEventsService: AccountingEventsService,
    public dialogRef: MatDialogRef<AccountingEventsEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit() {
    this.constants.title = this.appConfig.LANG.accountingEvents.title;

    this.accountingEventForm = new FormGroup({
      id: new FormControl('', Validators.required),
      name: new FormControl('', Validators.required)
    });

    this.constants.action = this.data.action;

    if (this.constants.action === this.appConfig.ACTIONS.edit.id) {
      this.constants.title =
        this.appConfig.LANG.title.edit + ' ' + this.constants.title;
      this.accountingEvent = this.data.item;
      this.accountingEventForm.patchValue({
        id: this.accountingEvent.id,
        name: this.accountingEvent.name
      });
    } else if (this.constants.action === this.appConfig.ACTIONS.add.id) {
      this.constants.title =
        this.appConfig.LANG.title.add + ' ' + this.constants.title;
    }
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  onSubmit() {
    const form = this.accountingEventForm;
    if (form.dirty && form.valid) {
      this.generalsService.save(
        this.constants.action,
        form,
        this.dialogRef,
        this.accountingEventsService
      );
    } else {
      this.close();
    }
  }

  close() {
    this.dialogRef.close(300);
  }
}
